import styled from "styled-components";

export const ButtonLayout = styled.div<{ noPadding?: boolean }>`
    display: grid;
    justify-content: start;
    gap: 2.4rem;
    grid-auto-flow: column;
    padding: ${({ noPadding }) => (noPadding ? "0" : "0 2.4rem")};
`;
